import React from "react";
import InstituteFeesView from "@/pages/public/_shared/InstituteFeesView";
import { useMitcidco } from "./MitcidcoLayout";

export default function MitcidcoFees() {
  const data = useMitcidco() || {};
  const instId = data?.institute?.id || "";
  return (
    <div data-testid="mitcidco-fees">
      <div className="bg-gradient-to-r from-[#7C2D12] via-[#8A2F0E] to-[#5B1A0A] text-white">
        <div className="max-w-6xl mx-auto px-5 py-12">
          <div className="text-[10px] uppercase tracking-[0.35em] font-bold text-[#D4A017]">Know Your Fees</div>
          <h1 className="font-serif text-3xl sm:text-4xl mt-2">Fee Structure</h1>
          <p className="mt-2 text-white/80 text-sm max-w-2xl">Transparent, category-wise fee tables. Data is published and maintained by the Trust admin office.</p>
        </div>
      </div>
      <InstituteFeesView instituteId={instId} testidPrefix="mitcidco-fees" />
    </div>
  );
}
